export default __webpack_public_path__ + "static/media/office1-before2-2048w.beb657e4.png";